<div #photo class="photo h-100 fx-column x-center y-center" matTooltipPosition="above"
  [class.canmove]="viewModel.canReorder" [class.disabled]="viewModel.disabled"
  [class.selected]="viewModel.showSelected && viewModel.inUseIndex > -1" [matTooltip]="viewModel.tooltip"
  [matTooltipDisabled]="!viewModel.tooltip" (mouseenter)="isFocused = true" (mouseleave)="isFocused = false">
  <!-- Main card Image -->
  <div class="photo-card border" [attr.title]="title" [ngClass]="{
       'highlight-selected': viewModel.isSelected,
       'border-color-primary': viewModel.isSelected,
       'border-round': roundImg,
       'border-color-warn': viewModel.isRequired && viewModel.isDefault(),
       'text-warn': viewModel.isRequired && viewModel.isDefault()
     }">


    @if (!viewModel.isDefault()) {
    <div class="card-img">
      <div class="card-img-cover">
        <img #img [fallbackSize]="fallbackThumbnailSize" [id]="'img-' + viewModel.photo?.order"
          [lcPresignedPhoto]="viewModel.photo" [ngClass]="{'opacity-25': viewModel.canHide && viewModel?.photo?.hidden}"
          [size]="thumbnailSize" (load)="onImageLoaded(viewModel, $event)">
      </div>
    </div>
    }

    @if (viewModel.isDefault()) {
    <div class="default-img fx-column x-center y-center" [id]="'default-img-' + viewModel.photo?.order">
      <span class="material-icons-outlined">add_photo_alternate</span>
      <div class="font-weight-normal">Drop your image here</div>
    </div>
    }

    @if (viewModel?.loading?.isLoading) {
    <lc-spinner [showOverlay]="true" [spinnerText]="viewModel?.loading?.loadingText" />
    }

    <!-- Overlay -->
    <div class="overlay">


      <!--Favorites Button-->
      @if (viewModel.canFavorite || (viewModel.showFavorite && viewModel.photo.favorite)) {
      <a class="favorite-button" [class.clickable]="viewModel.canFavorite" [class.small]="viewModel.useSmallIcons"
        (click)="onToggleFavorite(viewModel); $event.stopPropagation();">
        @if (viewModel.photo.favorite) {
        <img class="favorite-icon favorite" src="/assets/images/fav_on_icon.svg">
        }
        @if (!viewModel.photo.favorite) {
        <img class="favorite-icon not-favorite" src="/assets/images/fav_off_icon.svg">
        }
      </a>
      }

      <!-- Photo Order Spinner -->
      @if (viewModel.canReorder || viewModel.showOrder) {
      <div class="photo-order">
        <span class="text-bottom order-number photo-index" [class.bg-warn]="viewModel.isDefault()"
          [hidden]="viewModel.isEditNumber"
          (click)="onEditOrder(viewModel, true); $event.stopPropagation();">{{viewModel.photo.order}}</span>
        <input #order class="form-control-number-sm order-input" min="1" type="number"
          [hidden]="!viewModel.isEditNumber" [max]="totalCount" [value]="viewModel.photo.order"
          (blur)="onReorder(viewModel, order.value)" (click)="$event.stopPropagation()"
          (keyup.enter)="onKeyEnter($event)" />
      </div>
      }

      <!-- Checkbox Photo -->
      @if (viewModel.canSelect) {
      <lc-checkbox class="select-img white" id="controlPrefix + '-checkbox'" name="select_photos"
        [(ngModel)]="viewModel.isSelected" (click)="$event.stopPropagation()" (toggled)="onSelected(viewModel)" />
      }

      <!-- Checkbox for hiding a website gallery photo -->
      @if (viewModel.canHide) {
      <button class="top-left archive-toggle xs" color="default" mat-mini-fab (click)="onHideClicked($event, viewModel)"
        (mouseenter)="showHover=true" (mouseleave)="showHover=false">
        <mat-icon class="material-icons-outlined">{{(viewModel?.photo?.hidden && !showHover) ||
          (!viewModel?.photo?.hidden && showHover) ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      }

      <!-- Download Button -->
      @if((isFocused || iconsPersist) && viewModel.canDownload) {
      <button class="download-button xs" color="default" mat-mini-fab
        (click)="onDownload(viewModel); $event.stopPropagation();">
        <mat-icon class="material-icons-outlined">download</mat-icon>
      </button>
      }
      <!-- Delete Button (Placement = Default) -->
      @if((isFocused || iconsPersist) && viewModel.canDelete && viewModel.iconPlacement === 'default') {
      <button class="delete-button xs" color="default" mat-mini-fab
        (click)="onDelete(viewModel); $event.stopPropagation()" (pointerdown)="$event.stopPropagation()">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
      }

      <!-- Edit/Delete Buttons (Placement = Corner) -->
      @if((isFocused || iconsPersist) && viewModel.iconPlacement === 'corner') {
      <div class="corner-buttons fx-row fx-gap-xs">
        @if (viewModel.canEdit) {
        <button class="edit-button xs" color="default" mat-mini-fab
          (click)="onEdit(viewModel); $event.stopPropagation()" (pointerdown)="$event.stopPropagation()">
          <mat-icon class="material-icons-outlined">crop</mat-icon>
        </button>
        }
        @if (viewModel.canDelete) {
        <button class="xs" color="default" mat-mini-fab (click)="onDelete(viewModel); $event.stopPropagation()"
          (pointerdown)="$event.stopPropagation()">
          <mat-icon>delete</mat-icon>
        </button>
        }
      </div>
      }

      <!-- Edit/Delete Button (Placement = Center) -->
      @if((isFocused || iconsPersist) && viewModel.iconPlacement === 'center') {
      <div class="edit-delete-buttons fx-row fx-gap-xs">
        @if (viewModel.canEdit) {
        <button class="edit-button xs" color="default" mat-mini-fab
          (click)="onEdit(viewModel); $event.stopPropagation();" (pointerdown)="$event.stopPropagation()">
          <mat-icon class="material-icons-outlined">crop</mat-icon>
        </button>
        }
        @if (viewModel.canDelete) {
        <button class="xs" color="default" mat-mini-fab (click)="onDelete(viewModel); $event.stopPropagation();"
          (pointerdown)="$event.stopPropagation()">
          <mat-icon>delete</mat-icon>
        </button>
        }
      </div>
      }
    </div>
  </div>
</div>